import { Navigate } from 'react-router-dom';
import { Spinner, Container, Row } from 'react-bootstrap';
import { useUserSelector } from 'services/UserSelectorContext';
import { PassportContextProvider } from 'hooks/usePassport';
import SideBar from '../Menu';

export const ProtectedRoute = ({ children, sidebar = true, pipedrive = false }) => {
  const { isLoggedIn, isLoading } = useUserSelector();

  if (!isLoggedIn && !isLoading) {
    if (pipedrive) {
      return <Navigate to="/login-pipedrive" replace />;
    } else {
      return <Navigate to="/login" replace />;
    }
  } else if (isLoading) {
    return <Spinner animation="grow" variant="info" size="lg" />;
  }

  return (
    <Row>
      {sidebar ? <SideBar /> : null}
      <Container className="text-center mt-2 mb-2 min-h-100">
        <PassportContextProvider>{children}</PassportContextProvider>
      </Container>
    </Row>
  );
};
